/** Stores Captive Consumption. */
import { STORES_DOC_TABS } from "@nexseed/shared";
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { ListPageSkeleton } from "@/components/app/skeletons";
import { useAuth } from "@/features/auth/store";
import { useFacilities } from "@/features/auth/use-facilities";
import { IssueListPage } from "@/features/stores/components/issue-list-page";

export const Route = createFileRoute("/_app/stores/captive")({
  validateSearch: z.object({
    tab: z.enum([...STORES_DOC_TABS, "waiting"]).default("submitted"),
    from: z.string().optional(),
    to: z.string().optional(),
    q: z.string().optional(),
    page: z.number().int().min(1).default(1),
  }),
  beforeLoad: () => {
    if (!useAuth.getState().can("stores.view")) throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const s = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { selected, ready } = useFacilities();
  if (!ready) return <ListPageSkeleton />;
  return (
    <IssueListPage
      title="Captive Consumption"
      description="Stores items consumed for a party: a C&F agent, a dealer or someone named."
      groups={["captive"]}
      facilityId={selected?.id}
      search={{ ...s, group: "captive" }}
      onSearch={({ group: _g, ...next }) =>
        void navigate({ search: (prev) => ({ ...prev, ...next }) })
      }
    />
  );
}
